import {
    SET_USERDATA
} from '../constants'
import store from '../store'

export const setuserData = userData => store.dispatch({ type: SET_USERDATA, userData })

 